import React, {Component} from 'react';



class GetScaricaApp extends Component {


    constructor(props) {
        super(props);
        this.Click = this.Click.bind(this);

        this.androidLink = "https://play.google.com/store/apps/details?id=com.kaleidosstudio.natural_remedies";
        this.iosLink = "https://itunes.apple.com/us/app/the-natural-remedies/id1081776412";

        this.PageData = global.api.pagesData["scarica"];

        this.title = "";
        this.description = "";

        try {
            document.title = this.PageData.title[global.api.CurrentLanguage];
        }
        catch (err) {
        }

        if(global.api.CurrentLanguage === "it")
        {
            this.title = "Rimedi Naturali";
            this.description = "Scopri ciò che la natura ti offre per mantenere l'armonia del corpo e della mente";
        }
        else
        {
            this.title = "Natural Remedies";
            this.description = "Discover what nature can offer you in order to maintain the harmony of body and mind\n";
        }
    }

    componentDidMount() {

    }

    Click(link) {
        window.open(link, "_blank");
    }


    render() {

        let image = "";

        if(global.api.CurrentLanguage === "it")
        {
            image =  <img style={{width: '100%', height: 'auto', marginRight: '10px'}} src={require('./images/app_ita.jpg')} alt={"logo"}/>;
        }
        else
        {
            image =  <img style={{width: '100%', height: 'auto', marginRight: '10px'}} src={require('./images/app_en.jpg')} alt={"logo"}/>;
        }

        return (
            <div className="ContentSpacer fadeIn detailContent card" ref={'content'}>
                {image}


                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    marginTop: '35px'
                }}>
                    <div style={{fontSize:'27px'}}>{this.title}</div>
                    <div className={"BodyText"} style={{fontSize:'17px', marginTop:'15px', marginBottom:'15px'}}>{this.description}</div>

                    <div onClick={() => {
                        this.Click(this.androidLink)
                    }} className={"buttonAct"}>Google Play
                    </div>
                    <div onClick={() => {
                        this.Click(this.iosLink)
                    }} className={"buttonAct"}>iTunes
                    </div>


                </div>

            </div>
        );

    }
}

export default GetScaricaApp;





// WEBPACK FOOTER //
// ./src/include/GetScaricaApp.js